import { sendGetRequest } from 'redux/sagas/utils';
import { SERVER_IP } from 'assets/Config';

const MENU_SETTINGS_USER_URL = `${SERVER_IP}api/menu-settings/user`;

const normalizeMenuSettingsResponse = (response, gymId) => {
	const payload = response?.data?.data || response?.data || response;

	if (!payload || !Array.isArray(payload?.enabledMenus)) {
		return null;
	}

	return {
		...payload,
		gymId: payload.gymId || gymId,
	};
};

const fetchMenuSettingsForGym = async (gymId) => {
	if (!gymId) {
		return null;
	}

	const response = await sendGetRequest(null, `${MENU_SETTINGS_USER_URL}?gymId=${gymId}`);
	if (response?.status === 'Error') {
		return response;
	}

	return normalizeMenuSettingsResponse(response, gymId);
};

export const getMenuSettingsForUser = async ({ gymId }) => {
	try {
		return await fetchMenuSettingsForGym(gymId);
	} catch (error) {
		return {
			status: 'Error',
			error,
		};
	}
};

export const getAdminMenuSettings = async (gymId) => {
	try {
		return await fetchMenuSettingsForGym(gymId);
	} catch (error) {
		return {
			status: 'Error',
			error,
		};
	}
};